export default [
  { label: "Hombre", value: "male" },
  { label: "Mujer", value: "female" },
];
